import { Navigate, useRoutes } from 'react-router-dom';
import React,{  Suspense } from 'react';




const Anasayfa = React.lazy(() => import('./pages/Anasayfa/Anasayfa')); 
const Marka = React.lazy(() => import('./pages/Tanimlamalar/Marka')); 
const Model = React.lazy(() => import('./pages/Tanimlamalar/Model')); 
const Kullanici = React.lazy(() => import('./pages/Tanimlamalar/Kullanici')); 
const Armatur = React.lazy(() => import('./pages/Armaturler/Armatur')); 
const Serit = React.lazy(() => import('./pages/Armaturler/Serit')); 
const Tesis = React.lazy(() => import('./pages/Armaturler/Tesis')); 
const Yol = React.lazy(() => import('./pages/Armaturler/Yol')); 
const NotFound = React.lazy(() => import('./pages/Page404')); 
const Login = React.lazy(() => import('./pages/Login')); 
const Logout = React.lazy(() => import('./pages/Logout')); 

const DashboardLayout = React.lazy(() => import('./layouts/dashboard')); 
const LogoOnlyLayout = React.lazy(() => import('./layouts/LogoOnlyLayout')); 




// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/dashboard',
      element:  <Suspense fallback={<div>Yükleniyor...</div>}><DashboardLayout /></Suspense>,
      children: [
        { path: '/', element:    <Suspense fallback={<div>Yükleniyor...</div>}><Anasayfa /> </Suspense> },
    
        { path: 'anasayfa', element: <Suspense fallback={<div>Yükleniyor...</div>}><Anasayfa /> </Suspense>} ,
 
        { path: 'kullanici', element:  <Suspense fallback={<div>Yükleniyor...</div>}><Kullanici /></Suspense> },
    

       
        { path: 'marka', element:  <Suspense fallback={<div>Yükleniyor...</div>}><Marka /></Suspense> },
        { path: 'model', element:  <Suspense fallback={<div>Yükleniyor...</div>}><Model /></Suspense> },

        { path: 'armatur', element:  <Suspense fallback={<div>Yükleniyor...</div>}><Armatur /></Suspense> },
        { path: 'serit', element:  <Suspense fallback={<div>Yükleniyor...</div>}><Serit /></Suspense> },
        { path: 'tesis', element:  <Suspense fallback={<div>Yükleniyor...</div>}><Tesis /></Suspense> },
        { path: 'yol', element:  <Suspense fallback={<div>Yükleniyor...</div>}><Yol /> </Suspense>},

  

      ]
    },
    {
      path: '/',
      element:  <Suspense fallback={<div>Yükleniyor...</div>}><LogoOnlyLayout /></Suspense>,
      children: [
        { path: 'login', element:  <Suspense fallback={<div>Yükleniyor...</div>}><Login /></Suspense> },
        { path: 'logout', element:  <Suspense fallback={<div>Yükleniyor...</div>}><Logout /> </Suspense>},
      
        { path: '404', element:  <Suspense fallback={<div>Yükleniyor...</div>}><NotFound /></Suspense> },
        { path: '/', element: <Navigate to="/dashboard/anasayfa" /> },
        { path: '*', element: <Navigate to="/404" /> },
       
      ]
    },

    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
}
